<template>
  <qrcode-vue v-if="isQRCode" :value="getQRCode" :size="200" />
  <img v-else :src="uri" class="img-fluid" alt="..." />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";

export default defineComponent({
  name: "ImageComponent",
  components: { QrcodeVue },

  props: {
    uri: {
      required: true,
      type: String,
    },
  },

  computed: {
    // qrCode format should be 'javascript:qrCodeImage(someCodeToRender)'
    isQRCode(): boolean {
      return this.uri.startsWith("javascript:qrCodeImage");
    },

    getQRCode(): string {
      const qrCode = this.uri
        .replace("javascript:qrCodeImage(", "")
        .slice(0, -1);
      return qrCode;
    },
  },
});
</script>

<style scoped>
img {
  width: 90%;
  max-width: 120px !important;
}
</style>
